module.exports = __webpack_public_path__ + "img/portfolio-1.70fae66f.jpg";